import { Banner } from "components/DesignSystem/Banner/Banner";
import { Button } from "components/DesignSystem/Button/Button";
import { FilledTriangleWarning } from "components/icons/FilledTriangleWarning";
import { pluralize } from "utils/pluralize";

type MissingDetailsCalloutProps = {
  scope: "company" | "entity";
  totalMissing: number;
  onView: () => void;
};

const COMPANY_TITLE = "Complete your company information";
const ENTITY_TITLE = "Complete your entity information";

export const MissingDetailsCallout = ({
  scope,
  totalMissing,
  onView,
}: MissingDetailsCalloutProps) => {
  const title = scope === "company" ? COMPANY_TITLE : ENTITY_TITLE;
  const verb = totalMissing === 1 ? "is" : "are";
  const detailText = pluralize(totalMissing, "detail", "details");

  const body = (
    <div className="t-space-y-2">
      <div>
        {detailText} {verb} still missing. Review the remaining items to keep
        your records complete.
      </div>
      <Button size="small" onClick={onView}>
        View missing details
      </Button>
    </div>
  );

  return <Banner type="warning" title={title} description={body}></Banner>;
};
